import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAppContext } from "../Contexts/AppContext";
import ProductActions from "../Components/ProductActions";
import ProductImage from "../Components/ProductImage";
import { usePageTitle } from "../Utilities/usePageTitle";

const Cart = () => {
    usePageTitle('עגלת קניות');
    const { cart } = useAppContext();
    const [totalCart, setTotalCart] = useState(0);

    useEffect(() => {
        var total = cart.reduce((a, v) => a = a + v.itemTotal, 0);
        setTotalCart(total);
    }, [cart]);

    if (cart.length === 0) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '40vh' }}>
                <h4 className="fw-bold">סל הקניות ריק</h4>
            </div>
        );
    }

    return (
        <div className="container p-0" style={{ maxWidth: '950px' }}>
            <div className="p-3 p-md-5 m-md-3 rounded shadow bg-white">
                <div className="d-flex justify-content-between border-bottom border-success">
                    <h4>סל הקניות שלי</h4>
                </div>
                <br/>
                <div className="cart-items">
                    {cart.map((item) => (
                        <CartItem item={item} key={item.id} />
                    ))}
                    <div className="cart-summary">
                        <span>{cart.length} מוצרים בסל</span>
                        <span>סה"כ סל הקניות: <strong>{totalCart.toFixed(2)} ₪</strong></span>
                    </div>
                </div>
                <br/>
                <Link to="/checkout" className="btn btn-primary"> יאללה, לקופה! </Link>
            </div>
        </div>
    )
}

const CartItem = ({ item }) => {
    return (
        <div className="cart-item-grid">
            <div className="cart-item-image">
                <Link to={{ pathname: `/Product/${item.product.productUrl}` }}>
                    <ProductImage product={item.product} />
                </Link>
            </div>
            <div className="cart-item-details">
                <Link to={{ pathname: `/Product/${item.product.productUrl}` }}>
                    <div className="cart-item-name">{item.product.productName}</div>
                </Link>
                <div className="cart-item-price">
                    {item.product.price.toFixed(2)} ל{item.unit?.unitName ?? item.product.unit?.unitName}
                </div>
                {item.product.special && showIngredients(item.selectedIngredients)}
                {item.itemNotes && <div className="notes text-primary">{item.itemNotes}</div>}
            </div>
            <div className="cart-item-total">
                {item.itemTotal.toFixed(2)} ₪
            </div>
            <div className="cart-item-actions">
                <ProductActions
                    product={item.product}
                    showNotes={false}
                    className="d-flex flex-wrap align-items-center product-page"
                />
            </div>
        </div>
    )
};


const showIngredients = (ingredients) => {
    var ings = JSON.parse(ingredients);
    return (
        (ings != null)
            ? ings.map((ing, idx) => (
                <div key={idx} className="text-success">{ing.ingredientName}</div>
            ))
            : ''
    )
}


export default Cart;
